import { inject } from 'vue';
export function useAssets() {
    const assetsPath = inject('assetsPath', '/');
    function assetUrl(file) {
        if (!assetsPath)
            return file;
        return assetsPath.replace(/\/$/, '') + '/' + file.replace(/^\//, '');
    }
    return { assetUrl };
}
